export enum OrganizationFeatures {
  accessTags = "accessTags",
  allRolesAssignable = "allRolesAssignable",
  analytics = "analytics",
  autoConfirmDialogues = "autoConfirmDialogues",
  cannotUnassignSelf = "cannotUnassignSelf",
  caseCreate = "caseCreate",
  caseDashboard = "caseDashboard",
  caseDashboardAsSinglePage = "caseDashboardAsSinglePage",
  caseProgressCircle = "caseProgressCircle",
  caseRequest = "caseRequest",
  common = "common",
  directConnect = "directConnect",
  vCare = "vCare",
  feeBasedServices = "feeBasedServices",
  multiOpinionResponse = "multiOpinionResponse",
  userAdministration = "userAdministration",
  deviceAdministration = "deviceAdministration",
  notificationChimes = "notificationChimes",
  paymentsInSubmit = "paymentsInSubmit",
  signalR = "signalR",
  smsOptIn = "smsOptIn",
  taggedDocumentUploads = "taggedDocumentUploads",
  toastrPositionClass = "toastrPositionClass",
  virtualCare = "virtualCare",
  profile = "profile",
  contentManager = "contentManager",
  navigatorPortal = "navigatorPortal",
  communications = "communications",
  bottomNavigation = "bottomNavigation",
  termsOfService = "termsOfService",
  vCompanion = "vCompanion",
  userPermissions = "userPermissions",
  homePage = "homePage",
  initialDepartment = "initial-department",
  tagManager = "tagManager",
  runFerootPciScript = "runFerootPciScript"
}
